// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mb-3";
export var downloadButton = "_mb-4";
export var fileContainer = "_mb-9 _mb-7";
export var fileContainerBase = "_mb-7";
export var fileContainerFixedHeight = "_mb-8 _mb-7";
export var fileInfo = "_mb-5";
export var fileInfoWidthRestricted = "_mb-6";
export var fileType = "_mb-1";
export var fileTypeName = "_mb-2";
export var image = "_mb-0";
export var link = "_mb-b";
export var overflowEllipsis = "_mb-a";